<template>
  <div v-if="this.$store.state.bigMap === false" class="mapCell flex cursor-pointer" @click="$emit('clicked')">
    <div class="flex items-top w-full">
      <img :src="icon(tree)"  class="tree-icon"/>
      <div class="flex-1 flex flex-col ml-1 labels truncate">
        <div class="flex">
          <div class="flex flex-col">
          <label class="specieName truncate">
            {{$store.state.species.items[tree.specie].name}}
          </label>
          <label class="scientificName truncate reducesize">{{$store.state.species.items[tree.specie].scientificName}}</label>
          </div>
          <div class="flex flex-1 flex flex-col plantInfo full-h">
            <div v-if="!tree.ownerId" class="flex justify-end mt-2">
              <label  class="plantText label label-rounded label-primary truncate ">{{ $t('plantalo') }}</label>
            </div>
            <div v-else class="flex justify-end">
                <div class="avatarBack">
                  <img :src="avatar(owner)" class="miniAvatar"/>
                </div>
                <label class="ownerName truncate"> 
                   {{ $t('por') }} {{owner.name}}
                </label>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MapCell',
  props: {
    tree: {
      type: Object,
      required: true 
    },
  },
  data () {
    return {
      plantedIcon: require('@/assets/images/tree_icon_planted.svg'),
      unplantedIcon: require('@/assets/images/tree_icon.svg'),
    }
  },
  computed: {
    owner() {
      var response = this.$store.state.profiles[this.tree.ownerId]
      this.$store.dispatch('profiles/updateProfile', this.tree.ownerId)
      return response || {}
    }
  },
  methods: { 
    icon(tree) {
      if (tree.isPlanted) {
        return this.plantedIcon
      }
      return this.unplantedIcon
    },
    avatar(profile) {
      return profile.image || require('@/assets/images/profile.svg')
    }
  },
}
</script>

<style lang="scss">
@import '@/style/_variables.scss';
.reducesize {
  font-size: 0.6
}
.mapCell {
  position:absolute;
  border-radius: 5px;
  opacity: 0.95;
  background:white;
  bottom:28px;
  width:80%;
  right:10%;
  left:10%;
  padding: 15px;
  :hover {
    opacity: 1;
  }
  @media screen and (min-width: $break-large) {
    width: 460px;
    bottom: 30px;
    right: 25%;
    left: 50%;
    margin-left: -230px;
  }
  @media screen and (max-width: $break-small) {
    width:90%;
    right:5%;
    left:5%;
    padding: 10px;
    .plantText {
      max-width: 154px;
    }
  }
  .flex items-top w-full {
    padding-right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MapCell.vue